import {
    register,
    CloudObject,
    Tag,
    Transaction,
    defineProperty,
    defineRelation,
    Direction,
} from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class AndritzUser extends CloudObject {
    /**
     * Creates an instance of AndritzUser.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(AndritzUser);
    }

    /**
     * @return {string}
     */
    getFullname() {
        return this.get(AndritzUser.fullnameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeFullname($) {
        return this.observe($, AndritzUser.fullnameProp);
    }

    /**
     * @return {string}
     */
    getUsername() {
        return this.get(AndritzUser.usernameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeUsername($) {
        return this.observe($, AndritzUser.usernameProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setFullname(transaction, instance, value) {
        transaction.update(instance, AndritzUser.fullnameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setUsername(transaction, instance, value) {
        transaction.update(instance, AndritzUser.usernameProp, value);
    }
}

// Hardcoded tags
register('01880fbf0270f973636a', AndritzUser);
AndritzUser.fullnameProp = defineProperty('018824a6c2267a2c0f79');
AndritzUser.usernameProp = defineProperty('018a60519159e03e0efc');
AndritzUser.roleRel = defineRelation('01881f860ffc35b87099');
AndritzUser.inverse_assessmentcreatorRel = defineRelation('01880fbf6e03fe1db12a', Direction.ORIGIN);
AndritzUser.inverse_assessmentassigneeRel = defineRelation(
    '01880fbf9186d266a48b',
    Direction.ORIGIN
);
